import React from "react";
import { Trans } from "react-i18next";

import { CellProps } from "../../../../../components/dataGrid/dataGrid";
import Icon, { IconEnum } from "../../../../../components/icon";

import { TenantListViewModel } from "../../TenantList/tenantList.model";

import './tenantNameCell.scss';

const TenantNameCell: React.FC<CellProps<TenantListViewModel>> = ({ data: { displayValue, data } }) => {
    const { hasFlag, isConnected } = data;

    if (displayValue === null || displayValue === undefined) {
        return <span />;
    }

    return <div className="cell--tenant-name">
        <span>
            {isConnected && displayValue}
            {!isConnected && <Trans i18nKey="partnerPortal.tenantPending" values={{ tenantName: displayValue }} />}
        </span>
        {hasFlag && <Icon iconName={IconEnum.AlertTriangle} />}
    </div>
}

export default TenantNameCell;